import { render, staticRenderFns } from "./PageForgotUsername.vue?vue&type=template&id=13afc467&scoped=true&"
import script from "./PageForgotUsername.vue?vue&type=script&lang=js&"
export * from "./PageForgotUsername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afc467",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13afc467')) {
      api.createRecord('13afc467', component.options)
    } else {
      api.reload('13afc467', component.options)
    }
    module.hot.accept("./PageForgotUsername.vue?vue&type=template&id=13afc467&scoped=true&", function () {
      api.rerender('13afc467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/forgotpassword/PageForgotUsername.vue"
export default component.exports